import { AmplitudeFlagKey } from "@simplyk/common";

import { useAmplitudeFeatureFlag } from "./amplitude/useAmplitudeFeatureFlag";

export const useFamilyGroupMembershipFlag = (organizationId: string | undefined) =>
  useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.FamilyGroupMembership,
    organizationId,
    skip: !organizationId,
  });
